import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../theme/theme';

const ICON_PATHS: Record<string, string> = {
  'Bookings & Scheduling': 'M3 10h18M8 3v4M16 3v4',
  'Payments & Packs': 'M2 10h20',
  'Member Experience':
    'M12 20s-7-4.35-9.5-8.5C.8 8 2 4.5 5.5 4c2-.3 3.7.8 4.5 2.3C10.8 4.8 12.5 3.7 14.5 4 18 4.5 19.2 8 17.5 11.5 15 15.65 12 20 12 20z',
  Merchandise: 'M6 8h12l1 12.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 20.5L6 8zM9 8V6a3 3 0 0 1 6 0v2',
  'Messaging & Notifications': 'M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8A2.5 2.5 0 0 1 17.5 16H10l-4.5 4v-4H6.5A2.5 2.5 0 0 1 4 13.5v-8z',
  'Reporting & Analytics': 'M4 20V10M12 20V4M20 20v-7',
  'Partner & Integrations':
    'M9 15l6-6M8.5 10.5L6 8a3 3 0 1 1 4.24-4.24l1.3 1.3M15.5 13.5 18 16a3 3 0 1 1-4.24 4.24l-1.3-1.3',
  Other: 'M12 3l1.6 5.4L19 10l-5.4 1.6L12 17l-1.6-5.4L5 10l5.4-1.6L12 3z',
};

/** A couple of categories need an extra shape (a rect) alongside the path above. */
const EXTRA_RECT: Record<string, { x: number; y: number; w: number; h: number; rx: number }> = {
  'Bookings & Scheduling': { x: 3, y: 5, w: 18, h: 16, rx: 3 },
  'Payments & Packs': { x: 2, y: 6, w: 20, h: 13, rx: 2.5 },
};

interface CategoryChipProps {
  category: string;
  size?: 'small' | 'medium';
}

const CategoryChip: React.FC<CategoryChipProps> = ({ category, size = 'small' }) => {
  const path = ICON_PATHS[category];
  const rect = EXTRA_RECT[category];
  const compact = size === 'small';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: compact ? '5px 10px' : '6px 12px',
        borderRadius: '20px',
        backgroundColor: colors.backgroundTertiary,
      }}
    >
      {path && (
        <svg width={compact ? 12 : 13} height={compact ? 12 : 13} viewBox="0 0 24 24" fill="none" stroke="#77778a" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
          {rect && <rect x={rect.x} y={rect.y} width={rect.w} height={rect.h} rx={rect.rx} />}
          <path d={path} />
        </svg>
      )}
      <Typography sx={{ fontSize: compact ? 11.5 : 12.5, fontWeight: 600, color: '#5c5c66' }}>{category}</Typography>
    </Box>
  );
};

export default CategoryChip;
